/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import withBillingDetails from '@modules/billing-lib/billingDetails/withBillingDetails'

import { fetchSaasOrganization } from '@/actions/saasOrganizations'
import { fetchSaasOrganizationRequest } from '@/reducers/asyncRequests/registry'

import ChangeBillingAccountFlyout from './ChangeBillingAccountFlyout'
import { DispatchProps, StateProps } from './types'

import type { ReduxState, ThunkDispatch } from '@/types/redux'

const mapStateToProps = (state: ReduxState, organizationId: string): StateProps => ({
  fetchSaasOrganizationRequest: fetchSaasOrganizationRequest(state, organizationId),
})

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  fetchSaasOrganization: (organizationId) => dispatch(fetchSaasOrganization({ organizationId })),
})

export default connect<StateProps, DispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(withBillingDetails(ChangeBillingAccountFlyout))
